import { useCallback, useEffect, useMemo, useState } from "react";
import ApiService from "../network/ApiService";

const REFRESH_INTERVAL_MS = 60_000;

export default function useTransferWindow() {
  const apiService = useMemo(() => new ApiService(), []);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const response = await apiService.get("app/transfer/isOpen");
      const nextValue =
        typeof response === "boolean"
          ? response
          : Boolean(response?.is_open ?? response?.isOpen);

      setIsOpen(nextValue);
      return nextValue;
    } catch (error) {
      // Access is deliberately fail-closed if the current setting cannot be read.
      console.error("Failed to refresh transfer-window status:", error);
      setIsOpen(false);
      return false;
    } finally {
      setLoading(false);
    }
  }, [apiService]);

  useEffect(() => {
    refresh();

    const handleFocus = () => refresh();
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") refresh();
    };
    const intervalId = window.setInterval(refresh, REFRESH_INTERVAL_MS);

    window.addEventListener("focus", handleFocus);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.clearInterval(intervalId);
      window.removeEventListener("focus", handleFocus);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [refresh]);

  return { isOpen, loading, refresh };
}
